import { AfterViewInit, Component, Input, ChangeDetectionStrategy } from "@angular/core";
import * as Highcharts from 'highcharts/highstock';
import {MatTabsModule} from '@angular/material/tabs';
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { PollResultService } from "../../poll-result.service";
import { PollResultValue } from "../../poll-result.type";
@Component({
    selector: "agree-disagree-question-result-bar-chart",
    templateUrl: "./agree-disagree-question-result-bar-chart.component.html",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatTabsModule,
        TranslateModule
    ]
})
export class AgreeDisagreeQuestionResultBarChartComponent implements AfterViewInit {
    
    @Input() values: PollResultValue[];
    @Input() chartId: string
    constructor(
        private pollResultService: PollResultService,
        private translateService: TranslateService
    ) {}

    ngAfterViewInit(){
        const chartData = this.pollResultService.formatAgreeDisagreePollResult(this.values)
        Highcharts.chart('questionBarResult' + this.chartId, this.resultChartConfig(chartData) as any)
    }

    resultChartConfig (chartData) {
        return {
            chart: {
                type: 'bar',
                height: 350,
                marginBottom: 190
            },
            title: {
                text: '',                    
            },
            xAxis: {
                categories: [''],
            },
            yAxis: {
                min: 0,
                title: {
                    text: this.translateService.instant('poll_results.people_number')
                }
            },
            legend: {
                title: {
                    text: 'Options <i style="font-size: 9px; padding-top: 5px' +
                        'font-weight: normal">('+ this.translateService.instant('poll_results_chart.hide_options') +')</i>',
                },
                layout: 'vertical',
                align: 'left',
                floating: true,
                y: 20,
                itemStyle: {
                    color: '#6c757d',
                    fontWeight: 'normal',
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: true,
                        zIndex: 6,
                        verticalAlign: 'bottom',
                        style: {
                            fontSize: '12px',
                            textOutline: 'none',
                            color: 'white',
                            fontWeight: 400
                        },
                        formatter: function() {
                            if (this.point.shapeArgs.height < this.point.series.name.length * 2) {
                              return
                            } else {
                              return (this.y/this.total * 100).toFixed(1) + '%'
                            }
                          },
                    }
                }
            },
            tooltip: {
                headerFormat: '',
                pointFormat: '{point.series.name}: {point.y} ' + this.translateService.instant('poll_results.people')
            },
            exporting: {
                buttons: {
                    contextButton: {
                        enabled: false
                    }
                }
            },
            series: chartData 
        }
    }
}